import { AccountArrowDownOutlineIcon } from './AccountArrowDownOutlineIcon';

/**
 * author: Colton Wiscombe
 * id 8149AE23-C281-4BB3-8150-A5988CE17CD2
 * name account-arrow-down-outline
 * version: 6.2.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/account-arrow-down-outline.svg
 * tags
 * - Account / User 
 */
export const AccountDownloadOutlineIcon = AccountArrowDownOutlineIcon;
export default AccountDownloadOutlineIcon